module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<!-- ABTest: homepage descriptions :: id used by growth team -->\n<section class=\"js-le-carousel\"\n         data-displayId=\"")
    ; __append(escapeFn( displayId ))
    ; __append("\"\n         data-recoId=\"")
    ; __append(escapeFn( recoId ))
    ; __append("\"\n    ")
    ;  if(typeof carouselId !== 'undefined') { 
    ; __append("\n        data-carouselId=\"")
    ; __append(escapeFn( carouselId ))
    ; __append("\"\n     ")
    ;  } 
    ; __append("\n    ")
    ;  if(typeof rankModel !== 'undefined') { 
    ; __append("\n        data-rankModel=\"")
    ; __append(escapeFn( rankModel ))
    ; __append("\"\n    ")
    ;  } 
    ; __append("\n         id=\"")
    ;  if (typeof id !== 'undefined') { 
    ; __append(escapeFn( id ))
    ;  } 
    ; __append("\"\n         data-title=\"")
    ; __append(escapeFn( title ))
    ; __append("\"\n         data-model=\"")
    ;  if (typeof model !== 'undefined') { 
    ; __append(escapeFn( model ))
    ;  } 
    ; __append("\"\n         data-position=\"")
    ; __append(escapeFn( position ))
    ; __append("\">\n    <div class=\"carousel-content\">\n        <div class=\"carousel-width-wrapper\">\n            <div class=\"carousel js-video-carousel hidden\" id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" data-displayId=\"")
    ; __append(escapeFn( displayId ))
    ; __append("\">\n            </div>\n        </div>\n    </div>\n</section>\n")
  }
  return __output;

}